import React from 'react';
import '../../assets/scss/components/form/list-inputs.scss';

const ListInputs = ({children, ...props}) => {
    return (
        <div className="list-inputs">
            { children }
        </div>
    );
};

export default ListInputs;
